import React from 'react';
import { useStaticQuery, graphql, Link } from 'gatsby';
import PropTypes from 'prop-types';
import Box from 'reusecore/src/elements/Box';
import Text from 'reusecore/src/elements/Text';
import Heading from 'reusecore/src/elements/Heading';
import FeatureBlock from 'common/src/components/FeatureBlock';
import Image from 'reusecore/src/elements/Image';
import Container from 'common/src/components/UI/Container';

const FeatureSection = ({
  sectionWrapper,
  secTitleWrapper,
  secText,
  secHeading,
  row,
  col,
  FeatureItemStyle,
  iconStyle,
  contentStyle,
  featureTitle,
  featureDescription,
}) => {
  const Data = useStaticQuery(graphql`
    query {
      saasModernJson {
        FEATURES {
          title
          description
          moreInfoUrl
          moreInfoText
          icon {
            publicURL
          }
        }
      }
    }
  `);

  return (
    <Box {...sectionWrapper} as="section" id="features_section">
      <Container>
        <Box {...secTitleWrapper}>
          <Text {...secText} content="FEATURES" />
          <Heading
            {...secHeading}
            content="What can PrintableCal do for me?"
          />
        </Box>

        <Box {...row}>
          {Data.saasModernJson.FEATURES.map((item, index) => (
            <Box {...col} key={`feature-item-${index}`}>
              <FeatureBlock
                icon={
                  <Image
                    src={item.icon.publicURL}
                    alt={`feature-item-icon-${index + 1}`}
                  />
                }
                wrapperStyle={FeatureItemStyle}
                iconStyle={iconStyle}
                contentStyle={contentStyle}
                iconPosition="left"
                title={
                  <Heading as="h3" content={item.title} {...featureTitle} />
                }
                description={
                  <>
                    <Text content={item.description} {...featureDescription} />
                    <Link to={item.moreInfoUrl}>{item.moreInfoText}</Link>
                  </>
                }
              />
            </Box>
          ))}
        </Box>
      </Container>
    </Box>
  );
};

FeatureSection.propTypes = {
  sectionHeader: PropTypes.object,
  sectionWrapper: PropTypes.object,
  secTitleWrapper: PropTypes.object,
  secText: PropTypes.object,
  secHeading: PropTypes.object,
  row: PropTypes.object,
  col: PropTypes.object,
  FeatureItemStyle: PropTypes.object,
  iconStyle: PropTypes.object,
  contentStyle: PropTypes.object,
  featureTitle: PropTypes.object,
  featureDescription: PropTypes.object,
};

FeatureSection.defaultProps = {
  sectionWrapper: {
    pt: 100,
    pb: 40,
  },
  secTitleWrapper: {
    mb: ['60px', '100px'],
  },
  secText: {
    as: 'span',
    display: 'block',
    textAlign: 'center',
    fontSize: '14px',
    letterSpacing: '0.15em',
    fontWeight: '700',
    color: '#007C3E',
    mb: '5px',
  },
  secHeading: {
    fontSize: ['32px', '32px', '40px', '42px', '46px'],
    fontFamily: 'Google Sans',
    fontWeight: '500',
    letterSpacing: '-0.5px',
    lineHeight: '1.17857',
    textAlign: 'center',
    color: '#0f2137',
    mb: '0',
  },
  row: {
    flexBox: true,
    flexWrap: 'wrap',
    ml: ['-30px', '-30px', '-30px', '-30px', '-30px'],
    mr: ['-30px', '-30px', '-30px', '-30px', '-45px'],
  },
  col: {
    width: [1, 1 / 2, 1 / 2, 1 / 3],
    pl: ['30px', '30px', '30px', '30px', '45px'],
    pr: ['30px', '30px', '30px', '30px', '45px'],
    mb: ['50px', '70px'],
  },
  FeatureItemStyle: {
    alignItems: 'top',
  },
  iconStyle: {
    width: ['90px', '90px', '90px', '75px', '90px'],
    pr: '20px',
  },
  featureTitle: {
    fontSize: ['18px', '22px'],
    fontWeight: '500',
    color: '#0f2137',
    letterSpacing: '-0.025em',
    lineHeight: '1.4',
    mb: ['10px', '15px'],
  },
  featureDescription: {
    fontSize: '15px',
    fontWeight: '500',
    color: '#5d646d',
    letterSpacing: '-0.025em',
    lineHeight: '1.6',
    mb: '12px',
  },
};

export default FeatureSection;
